var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Box, styled, Typography } from '@mui/material';
import React from 'react';
var Root = styled(Box)(function (_a) {
    var theme = _a.theme;
    return ({
        alignItems: 'flex-start',
        color: theme.palette.text.secondary,
        display: 'flex',
        flexDirection: 'row',
    });
});
var Label = styled(Typography)({ fontWeight: 500 });
var Required = styled(Typography)(function (_a) {
    var theme = _a.theme;
    return ({
        color: theme.palette.error.main,
        margin: "0 ".concat(theme.spacing(0.5)),
    });
});
var Optional = styled(Typography)(function (_a) {
    var theme = _a.theme;
    return ({
        fontWeight: 'normal',
        margin: "0 ".concat(theme.spacing(0.5)),
    });
});
var FormLabel = function (_a) {
    var boldLabel = _a.boldLabel, className = _a.className, children = _a.children, name = _a.name, optional = _a.optional, required = _a.required;
    return (React.createElement(Root, __assign({}, { className: className }),
        React.createElement("label", { htmlFor: name },
            React.createElement(Label, { variant: "body2" }, boldLabel ? React.createElement("strong", null, children) : children)),
        required && React.createElement(Required, { variant: "body2" }, "*"),
        optional && React.createElement(Optional, { variant: "body2" },
            "(",
            optional,
            ")")));
};
export default FormLabel;
